<template>
  <div id="campaignSettings">
    <v-form ref="campaignSettingsForm">
      <v-container>
        <v-layout class="pr-4 pl-4 button-container">
          <v-flex sm12 md12 v-if="isFormDataChanged" class="pr-0 text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="reset">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pb-4">
            <v-flex sm6 md4>
              <v-text-field required v-model.number="campaignSettings.min_budget" :rules="rules.min_budget" label="Minimum monthly budget amount" class="required pr-4 pl-4" @input="isFormDataChanged = true" prepend-inner-icon="attach_money"></v-text-field>
            </v-flex>
            <v-flex sm6 md4>
              <v-text-field required v-model.number="campaignSettings.startup_fee" :rules="rules.startup_fee" label="Startup fee" class="required pr-4 pl-4" @input="isFormDataChanged = true" prepend-inner-icon="attach_money"></v-text-field>
            </v-flex>
            <v-flex sm6 md4 class="pf-pos-relative">
              <v-text-field required v-model.number="campaignSettings.admin_fee" :rules="rules.admin_fee" label="Admin fee (%)" class="required pr-4 pl-4" @input="isFormDataChanged = true"></v-text-field>
              <span class="pf-pos-absolute adminFeeSpan">${{ (campaignSettings.admin_fee/100)*campaignSettings.min_budget }}</span>
            </v-flex>
            <v-flex sm6 md4>
              <v-select v-model="campaignSettings.min_period" label="Minimum period (months)" :items="[3, 4, 5, 6, 9, 12]" :rules="rules.min_period" class="pr-4 pl-4" @change="isFormDataChanged = true"></v-select>
            </v-flex>
            <v-flex sm6 md4>
              <v-text-field required v-model.number="campaignSettings.shared_days" :rules="rules.shared_days" label="Budget sharing days" class="required pr-4 pl-4" @input="isFormDataChanged = true"></v-text-field>
            </v-flex>
            <v-flex xs12 class="required pr-4 pl-4 mt-2">
              <p class="pf-font-18">Terms and Conditions</p>
              <editor :options="editorOption" :init="editorInit" :api-key="editorApikey" v-model="campaignSettings.TnC" @input="isFormDataChanged = true" />
            </v-flex>
        </v-layout>
        <v-layout class="button-container pr-4 pl-4">
          <v-flex sm12 md12 v-if="isFormDataChanged" class="pr-0 text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="reset">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
/* global session store config */
/* eslint complexity: ["error", 22] */
import { mapGetters } from 'vuex';
import { update } from '../../helpers/helpers';
import swal from 'sweetalert2';
import Editor from '@tinymce/tinymce-vue';

export default {
  components: {
    'editor': Editor
  },
  data: vm => ({
    isFormDataChanged: false,
    campaignSettings: {
      startup_fee: 199, // $199
      admin_fee: 5, // 10%
      min_period: 3, // months
      min_budget: 99, // $99
      shared_days: 34.1,
      TnC: ''
    },
    editorOption: {
      'initial-value': 'Add terms and conditions here..',
    },
    editorInit: {
      height: 500,
      selector: 'pageEditor#full-featured-non-premium',
      menubar: true,
      plugins: ['advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount emoticons'],
      toolbar: 'undo redo | bold italic backcolor | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | forecolor backcolor removeformat | pagebreak | charmap emoticons | preview | insertfile image media template link anchor codesample | ltr rtl'
    },
    editorApikey: config.tinymceEditorKey,
    rules: {
      startup_fee: [
        v => !!v || 'Startup fee is required',
        v => !isNaN(v) || 'Please enter a number'
      ],
      admin_fee: [
        v => !!v || 'Admin fee is required',
        v => !isNaN(v) || 'Please enter a number'
      ],
      min_period: [
        v => !!v || 'Minimum month is required',
        v => !isNaN(v) || 'Please enter a number'
      ],
      min_budget: [
        v => !!v || 'Minimum budget is required',
        v => !isNaN(v) || 'Please enter a number'
      ],
      shared_days: [
        v => !!v || 'Budget sharing days is required',
        v => !isNaN(v) || 'Please enter a number'
      ]
    }
  }),
  computed: {
    ...mapGetters(['Agency']),

    Campaign: {
      get () {
        return store.state.Campaign;
      },
      set (value) {
        store.commit('setCampaign', value);
      }
    }
  },
  created () {
    if (this.Agency.campaign_settings && Object.keys(this.Agency.campaign_settings).length) {
      this.campaignSettings = JSON.parse(JSON.stringify(this.Agency.campaign_settings));
      if (!this.campaignSettings.shared_days) {
        this.campaignSettings.shared_days = 34.1;
      }
      if (!this.campaignSettings.TnC) {
        this.campaignSettings.TnC = '';
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async save () {
      if (this.isFormDataChanged && this.$refs.campaignSettingsForm.validate()) {
        /* Check if the TnC filled */
        if (this.campaignSettings.TnC === '' || this.campaignSettings.TnC === '<p> </p>') {
          swal.fire({
            type: 'warning',
            title: 'Terms and Conditions required.',
            text: 'Please add terms and conditons to proceed',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
          return;
        }        
        this.Agency.campaign_settings = JSON.parse(JSON.stringify(this.campaignSettings));
        let { error, data, status } = await update('Agency', this.Agency, this.Agency.id);
        if (error) {
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Unable to save your data, please try again, ' + error
          };
        } else {
          swal.fire({
            type: 'success',
            title: 'Campaign settings updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.hideButtons();
            }
          });
        }
      }
    },
    hideButtons () {
      this.isFormDataChanged = false;
    },
    reset () {
      this.campaignSettings = JSON.parse(JSON.stringify(this.Agency.campaign_settings));
      this.hideButtons();
    },
  }
};
</script>

<style lang="css" scoped>
  .adminFeeSpan {
    right: 30px;
    bottom: 0;
    opacity: .8;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Campaign/admin_settings.vue